<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'App',
}
</script>

<style>
@font-face {
  font-family: 'iconfont';  /* Project id 5136397 */
  src: url('//at.alicdn.com/t/c/font_5136397_7o2s7epuhlm.woff2?t=1778294107809') format('woff2'),
       url('//at.alicdn.com/t/c/font_5136397_7o2s7epuhlm.woff?t=1778294107809') format('woff'),
       url('//at.alicdn.com/t/c/font_5136397_7o2s7epuhlm.ttf?t=1778294107809') format('truetype');
}

*{line-height:1em;-webkit-tap-highlight-color:transparent;}
html{font-size:14px;}
body,h1,h2,h3,h4,dl,dt,dd,ul,ol,li,p,input,textarea{margin:0;padding:0;}
ul,li{list-style:none;}
img{display:block;}
i{font-style:normal;font-family:'iconfont';}
input,textarea{background:none;border:0;outline:none;}
a:link,a:visited{color:#000;text-decoration:none;}

#app{font-family:Arial;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#000;}
.container{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;background:url(~@/assets/images/index_bg.jpg) no-repeat;background-size:cover;}
.pop-frame{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background:rgba(0,0,0,.5);z-index:9;user-select:none;}
</style>
